import * as Yup from "yup";
const OrganizationEditValidation = Yup.object().shape({
  cbsTests: Yup.array().of(Yup.string()).min(1),
});

export default OrganizationEditValidation;
